export default __webpack_public_path__ + "static/media/x_wdt_c_3.5e625aa6.mp3";